import { AfterViewInit, Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BreadcrumbService } from 'xng-breadcrumb';
import { PaymentsService } from 'src/app/services/payments.service';
import { environment } from 'src/environments/environment';
import { SupportService } from 'src/app/services/support.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { SlackService } from 'src/app/services/slack.service';
import { ModalInvoiceConfigComponent } from 'src/app/components/modals/modal-invoice-config.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ModalAddConceptBillComponent } from 'src/app/components/modals/modal-add-concept-bill.component';
import { AuditTrailOffcanvasComponent } from 'src/app/shared/components/audit-trail-offcanvas.component';

import { Bill } from 'src/app/models/bill.model';
import { BillItem } from 'src/app/models/bill-item.model';
import { Unit } from 'src/app/models/unit.model';
import { Settlement } from 'src/app/models/settlement.model';
import { Building } from 'src/app/models/building.model';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { IrregularConsumptionsReportService } from '../irregular-consumptions-report/services/irregular-consumptions-report.service';
import { BillPublishResponse } from '../irregular-consumptions-report/models/bill-publish-response.interface';
import { forkJoin, Observable, of, switchMap, tap } from 'rxjs';
import { AlertResolution } from '../irregular-consumptions-report/models/consumption-alerts-resolution.interface';
import {
  findActiveReconnectionFee,
  RECONNECTION_FEE_ITEM_TYPE,
  resolveReconnectionFee
} from 'src/app/shared/utils/reconnection-fee.utils';

@Component({
  selector: 'app-show-bill',
  template: `
    <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Recibos</h1>
      </div>      
    </div>
    <div class="d-flex">
      <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
        <ul #sidebar app-nav-payments [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill" style="min-width: 440px !important; width: 440px !important;">
        <form [formGroup]="billForm" >
          <div class="list-group mb-5">
            <div class="list-group-item py-3">
              <div class="d-flex">
                <div>
                  <h2 class="mb-0">{{unit?.name}}</h2>
                  <h4 class="mb-0" style="font-size: 18px;">{{settlement?.name}}</h4>
                  <h3 style="font-size: 16px;">{{building?.name}}</h3>
                </div>
                <div class="ms-auto text-end" *ngIf="bill">
                  <h4># {{bill.id}}</h4>
                  <button 
                    type="button" 
                    class="btn btn-sm btn-outline-secondary mb-2" 
                    data-bs-toggle="offcanvas" 
                    data-bs-target="#auditTrailOffcanvas"
                    (click)="loadAuditTrail()"
                  >
                    <fa-icon [icon]="icons.faHistory" class="me-1"></fa-icon>
                    Historial
                  </button>
                  <br>
                  <div class="badge" [ngClass]="getState(bill.state)">{{getStatus(bill.state)}}</div><br>
                  <div class="badge" [ngClass]="getBillStatus(bill.status)">{{billStatus(bill.status)}}</div><br>
                  <div class="badge bg-info" *ngIf="bill?.invoiced">Facturado</div>
                </div>
              </div>
              <div class="mt-3">
                <table class="table table-sm mb-0" style="font-size: 0.8em;">
                  <tr>
                    <th>Inquilino</th>
                    <td class="text-end">{{tenant?.name}} {{tenant?.last_name}}</td>
                  </tr>
                  <tr>
                    <th>C.P.</th> 
                    <td class="text-end">{{fiscal?.zip_code}}</td>
                  </tr>
                  <tr>
                    <th class="mb-0">RFC</th> 
                    <td class="text-end">{{fiscal?.rfc}}</td>
                  </tr>
                  <tr>
                    <th>Razón social</th> 
                    <td class="text-end">{{fiscal?.razon_social}}</td>
                  </tr>                    
                  <tr>
                    <th>Régimen fiscal</th>
                    <td *ngIf="fiscal?.regimen_fiscal" class="text-end">{{regimenFiscal(fiscal?.regimen_fiscal).id}} - {{regimenFiscal(fiscal?.regimen_fiscal).name}}</td>
                  </tr>
                  <tr>
                    <th>Uso del CFDI</th>
                    <td *ngIf="fiscal?.uso_cfdi" class="text-end">{{usocfdi(fiscal?.uso_cfdi).id}} - {{usocfdi(fiscal?.uso_cfdi).name}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="list-group-item py-3" *ngIf="!bill?.adv">
              <app-receipt-reads 
                [bill]="bill" 
                [prev_bill]="prev_bill"
                (updateMeterRead)="updateMeterRead($event)"
              ></app-receipt-reads>
            </div>
            <div class="list-group-item py-3" *ngIf="!bill?.adv || bill?.state===0">
              <div class="clearfix">
                <h5 class="float-start mt-2">Servicios</h5>
                <div class="float-end">
                  <button type="button" (click)="addConcept()" class="btn btn-sm btn-zazz-dark" > <!-- *ngIf="bill?.state==0" -->
                    <fa-icon [icon]="icons.faPlus"></fa-icon>
                  </button>
                </div>
              </div>
              <div
                *ngIf="bill?.state === 0 && (reconnectionFeeAmount !== null || hasReconnectionFee)"
                class="d-flex align-items-center justify-content-between border-top mt-3 pt-3"
              >
                <div>
                  <strong>Cargo por reconexión</strong>
                  <div class="text-secondary text-sm">{{reconnectionFeeAmount | currency: 'MXN': 'symbol-narrow'}}</div>
                </div>
                <button
                  type="button"
                  class="btn btn-sm"
                  [ngClass]="hasReconnectionFee ? 'btn-outline-danger' : 'btn-zazz-dark'"
                  [disabled]="reconnectionFeeLoading || (!hasReconnectionFee && reconnectionFeeAmount === null)"
                  (click)="toggleReconnectionFee()"
                  [attr.aria-label]="hasReconnectionFee ? 'Quitar cargo por reconexión' : 'Agregar cargo por reconexión'"
                >
                  <fa-icon [icon]="icons.faCircleNotch" *ngIf="reconnectionFeeLoading" animation="spin" class="me-1"></fa-icon>
                  {{hasReconnectionFee ? 'Quitar' : 'Agregar'}}
                </button>
              </div>
            </div>
            <div class="list-group-item py-3">
              <h5 class="float-start mt-2">Productos</h5>
              <div class="float-end">
                <button type="button" (click)="addConcept()" class="btn btn-sm btn-zazz-dark" > <!-- *ngIf="bill?.state==0" -->
                  <fa-icon [icon]="icons.faPlus"></fa-icon>
                </button>
              </div>
            </div>
            <div class="list-group-item py-3" *ngIf="billForm">
              <h5>Referencia</h5>                  
              <div class="form-group mt-2">
                <label for="reference" class="form-label sr-only">Referencia</label>
                <input type="text" formControlName="reference" class="form-control">
                <div *ngIf="bfc['reference']?.touched && bfc['reference']?.invalid">
                  <div *ngIf="bfc['reference']?.errors?.['required']" class="text-danger text-sm">La referencia es requerido.</div>
                </div>
              </div>
            </div>
            <div class="list-group-item py-3" *ngIf="!bill?.adv">
              <div class="form-group">
                <label for="description" class="form-label">Comentarios</label>
                <textarea formControlName="description" class="form-control"></textarea>
              </div>
            </div>
            <div class="list-group-item py-3">
              <div class="d-flex justify-content-end">
                @if (!this.billCanBePublished().can_publish) {
                  <div class="irregular-consumption-message">
                    Recibo bloqueado por consumo irregular
                  </div>
                }
                <div><p class="">{{loadingMsg}}</p></div>
                <div class="ms-auto">
                  <div ngbDropdown class="d-inline-block" *ngIf="authService.hasPermission('can_edit_bills')">
                    <button type="button" class="btn btn-zazz-dark" id="dropdownBasic1" ngbDropdownToggle [disabled]="loading">
                      <fa-icon [icon]="icons.faSave" *ngIf="!loading" class="me-2"></fa-icon>
                      <fa-icon [icon]="icons.faCircleNotch" *ngIf="loading" animation="spin" class="me-2"></fa-icon>
                      Actualizar recibo
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                      <div *ngIf="bill?.total==0">
                        <button ngbDropdownItem [disabled]="bill?.state==1" (click)="payBill()">Marcar como pagado</button>
                      </div>
                      <div *ngIf="bill?.total!>0">

                        @if(!this.billCanBePublished().can_publish) {
                          @for (resolution of resolutions(); track $index) {
                            <button ngbDropdownItem (click)="patchResolution(resolution.id)">{{ resolution.description }}</button>
                          }
                          <div class="dropdown-divider"></div>
                        }
                        <button ngbDropdownItem 
                          (click)="regenerateReceipt()" 
                          *ngIf="bill?.state === 1" 
                          [disabled]="transaction?.transaction_id"
                        >Reemitir Recibo</button>

                        <button ngbDropdownItem 
                          *ngIf="bill?.invoiced == true" 
                          (click)="regenerateInvoice()"
                        >Regenerar factura</button>

                        <button ngbDropdownItem 
                          [disabled]="bill?.state === 1 || bill?.total! <= 0 || !this.billCanBePublished().can_publish" 
                          (click)="publishBill()"
                        >Emitir Recibo</button>
                        
                        <button ngbDropdownItem 
                          [disabled]="bill?.state === 1 || !this.billCanBePublished().can_publish" 
                          (click)="configInvoice()"
                        >Emitir Factura</button>
                      </div>
                      <button ngbDropdownItem 
                        *ngIf="bill?.state === 0 || !bill?.invoiced"
                        (click)="updateBill()"
                      >Guardar borrador</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="ms-2" style="width: 485px !important; min-width: 485px !important;">
        <div class="list-group mb-5">
          <div class="list-group-item py-3" *ngIf="prev_bill !== null">
            <app-item-bill-tiny 
              [bill]="prev_bill"
            ></app-item-bill-tiny>
          </div>          
          <div class="list-group-item py-3" *ngIf="!bill?.adv">
            <app-receipt-breakdown
              [bfc]="bfc"
              [bill]="bill"
              [bill_items]="bill?.bill_items ?? null"
              [prev_bill]="prev_bill"
              [interests]="5"
              (onDestroyItem)="removeItem($event)"
              (billUpdated)="onBillUpdated($event)"
              (loadBillByUpdate)="loadBill(this.billForm.value.id)"
            ></app-receipt-breakdown>
          </div>
          <div class="list-group-item py-3" *ngIf="transaction">
            <h5 class="mb-3">Transacción del recibo</h5>
            <div class="d-flex" *ngIf="transaction">
              <div class="ms-auto">
                <div class="badge bg-light py-2 px-2 me-2 border text-center">
                  <!-- img [src]="cardType(transaction?.payment_method_brand)" alt="Card image cap" width="44" --> 
                </div>
              </div>
              <div class="flex-fill ms-3">
                <h4 class="mb-0"><i># {{transaction?.transaction_id}}</i></h4>
                <p class="mb-0 text-sm">Importe de la transacción: <strong>{{transaction?.amount == null ? '—' : (transaction.amount | currency)}}</strong></p>
                <p class="mb-0 text-sm" *ngIf="transaction.applied_amount != null">Aplicado al recibo en esta transacción: <strong>{{transaction.applied_amount | currency}}</strong></p>
                <p class="mb-0 text-sm" *ngIf="transaction.balance_amount != null">Saldo a favor de esta transacción: <strong>{{transaction.balance_amount | currency}}</strong></p>
                <p class="mb-0 text-sm">Método de pago: <strong>{{transaction?.payment_method_type}}</strong></p>
                <p class="mb-0 text-sm" *ngIf="transaction.payment_date">Fecha de la transacción: <strong>{{transaction.payment_date | date: 'dd/MM/yyyy HH:mm'}}</strong></p>
                <p class="mb-0 text-sm">Última fecha de pago del recibo: <strong>{{(bill?.paid_date | date: 'dd/MM/yy') || '—'}}</strong></p>
              </div>
            </div>
          </div>
          <div class="list-group-item py-3" *ngIf="bill?.invoiced">
            <app-receipt-invoice [invoice]="invoice"></app-receipt-invoice>
          </div>
        </div>  
      </div>
    </div>
    <app-modal-invoice-config 
      [loading]="loading" 
      (saveInvoice)="publishInvoice($event)"
    ></app-modal-invoice-config>
    <app-modal-add-concept-bill 
      [concepts]="concepts" 
      (conceptData)="saveConcept($event)"
    ></app-modal-add-concept-bill>
    
    <app-audit-trail-offcanvas
      [auditData]="auditTrailData"
      [loading]="auditTrailLoading"
      objectType="bill"
      [customRenderer]="true"
    ></app-audit-trail-offcanvas>
  `,
  styleUrl: './show-bill.component.scss'
})
export class ShowBillComponent implements OnInit, AfterViewInit {
  consumptionsService = inject(IrregularConsumptionsReportService);
  bill: Bill | null = null;
  bill_items: BillItem[] | null = null;
  prev_bill: Bill | null = null;
  invoice: any = null;
  transaction: any = null;
  unit: Unit | null = null;
  settlement: Settlement | null = null;
  building: Building | null = null;
  buildings: Building[] | null = null;
  billForm: FormGroup = new FormGroup({});
  loading: boolean = false;
  reconnectionFeeLoading: boolean = false;
  
  profile: any = {};
  permissions: any = {};
  concepts: any[] = [];

  loadingMsg: string = '';
  currentView: string = 'bills';

  @ViewChild(ModalInvoiceConfigComponent) modalInvoiceConfig !: ModalInvoiceConfigComponent;
  @ViewChild(ModalAddConceptBillComponent) modalAddConceptBill !: ModalAddConceptBillComponent;

  token_ca: any;

  utilityData: any = null;

  invoiceForm: FormGroup = new FormGroup({});

  tanque: any = null;
  tenant: any = null;
  fiscal: any = null;

  invoiceData: any = {};
  // conceptos: any = [];
  serie: string = '';
  complemento: any = {};

  // Audit Trail properties
  auditTrailData: any = null;
  auditTrailLoading: boolean = false;
  storageService = inject(StorageService);
  transactionLocal = signal<{agreement: string, clabe: string, reference_name: string}>({
    agreement: '',
    clabe: '',
    reference_name: ''
  });
  billCanBePublished = signal<Partial<BillPublishResponse>>({});
  resolutions = signal<AlertResolution[]>([]);
  constructor(
    private store: SettlementsService,
    private paymentService: PaymentsService,
    private slackService: SlackService,
    private route: Router,
    private activateRoute: ActivatedRoute,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private image: ImageService,
    public icons: IconsService,
    public catalog: CatalogsService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS);
    this.utilityData = this.profile;

    console.log('utilityData => ', this.utilityData);

    this.store.getPaymentConcepts({ page: 1, per_page: 1000 }).subscribe((data: any) => {
      console.log('CONCEPTS DATA =====> ', data);
      this.concepts = data.data;
    });

    this.activateRoute.params.subscribe((params: any) => {
      this.loading = true;
      if (params['id'] != 'new') {
        this.loadBill(params['id']);
      } else {
        this.store.getBuildings({ page: 1, per_page: 1000 }).subscribe((data: any[]) => {
          this.buildings = data;
          this.loading = false;
        });
      }
    });
  }

  getStatus(status: any) {
    switch (status) {
      case 0:
        return 'Borrador';
      case 1:
        return 'Emitido';
      case 3:
        return 'Cancelado';
      case 4:
        return 'Pendiente';
      default:
        return 'N/A';
    }
  }

  getState(status: any) {
    switch (status) {
      case 0:
        return 'bg-warning';
      case 1:
        return 'bg-success';
      case 3:
        return 'bg-danger';
      case 4:
        return 'bg-info';
      default:
        return 'bg-secondary';
    }
  }

  billStatus (status: any) {
    switch (status) {
      case true:
        return 'Pagado';
      case false:
        return 'No pagado';
      default:
        return 'No pagado';
    }
  }

  getBillStatus (status: any) {
    switch (status) {
      case true:
        return 'bg-success';
      case false:
        return 'bg-danger';
      default:
        return 'bg-danger';
    }
  }

  usocfdi(uso_cfdi: any) {
    return this.catalog.usosCFDI.find((uso: any) => uso.id == uso_cfdi);
  }

  regimenFiscal(regimen: any) {
    return this.catalog.regimenes.find((reg: any) => reg.id == regimen);
  }

  ngOnInit(): void {
    this.buildForm();
    this.initForm();
    // this.loadLogo();
  }

  patchResolution(idResolution: number) {
    this.loading = true;
    this.consumptionsService.patchResolution(this.billCanBePublished().consumption_alert?.id!, idResolution)
      .subscribe({
        next: (res) => {
          this.toastr.success('Se ha actualizado la resolución');
          this.billCanBePublished.update(prev => ({...prev, can_publish: true}));
        },
        error: () => {
          this.toastr.warning('Antes de actualizar la resolución se necesita cambiar el status a Pendiente en el ícono ⚠️ en el reporte');
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        }
      });
  }

  billCanPublish() {
    forkJoin([this.consumptionsService.alertResolutions(true), this.consumptionsService.billCanPublish(this.bill?.id!)])
      .subscribe(
        ([resolutions, response]) => {
          this.billCanBePublished.set(response ?? {});
          this.resolutions.set(resolutions.data ?? []);
        }
      )
  }

  ngAfterViewInit(): void {}

  // async loadLogo() {
    // const img = this.image.buildURL(this.profile.logo);
    // const imx: any = await this.image.getBase64ImageFromUrl(img);
    // this.profile.logo = `data:image/jpeg;base64,${imx.split(',')[1]}`;
    // this.utilityData = this.profile;
  // }

  protected addConcept(): void {
    // this.addingConcept = true;
    const modalTemplate: any | undefined = this.modalAddConceptBill;
    if (modalTemplate) {
      this.modalAddConceptBill.openModal(modalTemplate['modalAddConceptBill']);
    }
  }

  protected get reconnectionFeeItem(): BillItem | undefined {
    return findActiveReconnectionFee(this.bill?.bill_items ?? this.bill_items);
  }

  protected get hasReconnectionFee(): boolean {
    return Boolean(this.reconnectionFeeItem);
  }

  protected get reconnectionFeeAmount(): number | null {
    const configuredFee = resolveReconnectionFee(this.unit, this.settlement);
    if (configuredFee !== null) {
      return configuredFee;
    }

    const itemTotal = Number(this.reconnectionFeeItem?.total);
    return Number.isFinite(itemTotal) ? itemTotal : null;
  }

  protected toggleReconnectionFee(): void {
    if (this.bill?.state !== 0 || this.reconnectionFeeLoading) {
      return;
    }

    const currentItem = this.reconnectionFeeItem;
    if (!currentItem && this.reconnectionFeeAmount === null) {
      this.toastr.error('No hay un costo de reconexión configurado para esta unidad o condominio', 'Error');
      return;
    }

    if (currentItem && currentItem.id == null) {
      return;
    }

    this.reconnectionFeeLoading = true;
    const request = currentItem
      ? this.store.deleteBillItem(currentItem.id)
      : this.store.addBillItem({
          bill_id: this.bill.id,
          item_type: RECONNECTION_FEE_ITEM_TYPE
        });

    request.subscribe({
      next: () => {
        const action = currentItem ? 'eliminado' : 'agregado';
        this.toastr.success(`Cargo por reconexión ${action} correctamente`, 'Éxito');
        this.reconnectionFeeLoading = false;
        this.loadBill(this.bill!.id);
      },
      error: (err: any) => {
        console.error('Error updating reconnection fee', err);
        this.toastr.error('Ocurrió un error al actualizar el cargo por reconexión', 'Error');
        this.reconnectionFeeLoading = false;
      }
    });
  }

  removeConcept(index: any) {
    // TODO: remove concept from bill
  }

  protected configInvoice(): void {
    const modalTemplate: any | undefined = this.modalInvoiceConfig;
    if (modalTemplate) {
      this.modalInvoiceConfig.openModal(modalTemplate['modalInvoiceConfig']);
    }
  }

  loadBill(id: any) {
    this.transaction = null;
    this.invoiceData = {};
    this.store.getBill(id).subscribe({
      next: async (data: any) => {
        console.log('data ==> ', data);
        this.bill = data;
        this.billForm.patchValue(this.bill!);

        console.log('Profile => ', this.profile);

        const token: any = `${this.profile.razon_social}_TOKEN_CA`;
        this.token_ca = environment[token as keyof typeof environment];
        console.log('TOKEN CA => ', this.token_ca);
        // 
        if (data.bill_items) {
          this.bill_items = data.bill_items;
        }

        

        if (this.bill && this.bill.state! > 0) {
          this.loadBillTransaction(this.bill.id);
        }

        if (this.bill && this.bill.invoiced) {
          this.store.getInvoiceByBill(this.bill.id).subscribe((data: any) => {
            console.log('INVOICE DATA => ', data);
            this.invoice = data;
          });
        }

        console.log('LOAD BILL ===> ', this.bill);

        this.store.getUnitSettlement(data.unit_id).subscribe(async (response: any) => {
          // console.log('GET UNIT SETTLEMENT DATA =====> ', response);
          this.settlement = response.settlement;
          this.building = response.building;
          this.unit = response.unit;
          this.tenant = response.tenants;
          this.fiscal = response.fiscal;
          
          this.invoiceForm.patchValue(this.fiscal);

          console.log('settlement data => ', this.settlement);
          if (this.settlement) {
            console.log('SETTLEMENT DATA => ');
            this.store.getPreviousBill(data.id).subscribe((prevBill: any) => {
              console.log('PREVIOUS BILL DATA => ', prevBill);
              // if (prevBill.id == this.bill?.id || this.bill?.cancel_interests) {
                // return;
              // }               
              this.prev_bill = prevBill;
            });
          }
        });

        this.loading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.loading = false;
      },
      complete: () => {
        this.billCanPublish();
      }
    });
  }

  buildForm() {
    this.billForm = this.fb.group({
      id: [''],
      reference: [''],
      description: [''],
      status: [''],
      consumo_m3: [''],
      consumo_lt: [''],
      consumo_periodo: [''],
      consumo_total: [''],
      taxes: [''],
      sub_total: [''],
      total: [''],
      days: [''],
      read_prev: [''],
      read_curr: [''],
      admin_price: [''],
      discount: [''],
      interests: [''],
      recargos: [''],
      periodo_inicio: [''],
      periodo_fin: [''],
      due_date: [''],
      paid_date: [''],
      subscription_id: [''],
      // additional_services: [''],
      // medidor: [''],
      // medidor_prev: [null],
      unit_id: [''],
      state: [''],
      pdf: [''],
      adv: [''],
      gas_price: [''],
      created_at: [''],
      updated_at: [''],
      cancel_interests: [''],
      cancel_recargos: [''],
      merchant_id: [''],
    });    
  }

  initForm(): void {
    this.invoiceForm = this.fb.group({
      rfc: ['', Validators.required],
      razon_social: ['', Validators.required],
      regimen_fiscal: ['', Validators.required],
      uso_cfdi: ['', Validators.required],
      zip_code: ['', Validators.required],
    });    
  }

  get bfc () {
    return this.billForm.controls;
  }

  updateMeterRead(gasMeterRead: any): void {
    console.log('UPDATE METER READ !!!!!!! ====> ', gasMeterRead);
    this.store.updateGasMeterRead(gasMeterRead.id, gasMeterRead).subscribe({
      next: (data: any) => {
        console.log('Gas meter read updated successfully', data);
        this.toastr.success('Lectura actualizada correctamente', 'Éxito');
        this.loadBill(this.billForm.value.id);
      }, 
      error: (err: any) => {
        console.error('Error updating gas meter read', err);
        this.toastr.error('Error al actualizar lectura de gas', 'Error');
      }
    });
  }

  protected saveConcept(billItem: any): void {
    console.log('SAVE CONCEPT =====> ', billItem);

    billItem.bill_id = this.billForm.value.id;
    billItem.sku = `${this.profile.rfc.substring(0, 3)}-${this.settlement?.id}-SRV`;

    console.log('BILL ITEM =====> ', billItem);
    this.store.addBillItem(billItem).subscribe({
      next: (data: any) => {
        console.log('Bill item added successfully', data);
        this.toastr.success('Concepto agregado correctamente', 'Éxito');
        this.loadBill(this.billForm.value.id);
      }, error: (err: any) => {
        console.log('Error adding bill item', err);
        this.toastr.error('Error al agregar concepto', 'Error');
      }
    });
  }

  protected calculateTotal(gasMeterRead: any): void {
    this.loading = true;
    const read_prev = this.billForm.value.read_prev;
    const read_curr = this.billForm.value.read_curr;

    // if (read_curr < read_prev) {
      // this.toastr.error('La lectura actual no puede ser menor a la anterior.', 'Error');
      // this.loading = false;
      // return;
    // }

    this.store.getBillCalculation({
      bill_id: this.billForm.value.id,
      gas_meter_read: gasMeterRead,
      cancel_interests: this.billForm.value.cancel_interests,
      cancel_recargos: this.billForm.value.cancel_recargos,
    }).subscribe({
      next: (data: any) => {

        console.log('CALCULATION DATA =====> ', data);

        this.bill = data;
        this.billForm.patchValue(data);
        // 
        if (data.bill_items) {
          this.bill_items = data.bill_items;
        }


        this.loading = false;
        this.toastr.success('Cálculo del recibo actualizado correctamente', 'Éxito');
      }, error: (err: any) => {
        console.log('calculateTotal ERROR => ', err);
        this.toastr.error('Ocurrió un error al calcular el recibo', 'Error');
        this.loading = false;
      }
    });
  }

  async publishBill() {
    this.loading = true;
    this.loadingMsg = 'Recopilando información del recibo..';

    if (this.billForm.invalid) {
      this.billForm.markAllAsTouched();
      this.toastr.error('Favor de llenar todos los campos', 'Error');
      this.loadingMsg = '';
      this.loading = false;
      return;
    }

    this.billForm.patchValue({ status: false, adv: false });

    let dueDate = new Date(this.bill?.due_date!);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    let rtry: string = this.bill!.retry > 0 ? `-${this.bill!.retry}` : '';

    this.billForm.patchValue({
      merchant_id: this.settlement?.merchant_id
    });

    // await this.updateBill();

    let paymanetData: any = {}
    let receiptPayload = {
      bill: this.billForm.value,
      bill_items: this.bill?.bill_items,
      prev_bill: this.prev_bill,
      dueDate: dueDate,
      unitData: this.unit,
      buildingData: this.settlement,
      paymentData: paymanetData,
      utilityData: this.utilityData,
      tenantData: this.tenant,
    };

    console.log('RECEIPT PAYLOAD =====> ', this.bill);

    const default_cus: string = `${this.profile.razon_social}_DEFAULT_CUS`;
    const generic_default_cus = environment[default_cus as keyof typeof environment];

    const payload: any = {
      process_token: this.token_ca, 
      unique_payment: true,
      transaction_id: `${this.billForm.value.id}-C${rtry}`, // payData.transaction_id,
      description: this.billForm.value.reference,
      expiration_interval_days: "30",
      currency_code: "MXN",
      amount: this.billForm.value.total?.toFixed(2),
      ip_address: "201.207.239.230",
      customer_username: this.tenant ? this.tenant.usename : 'ZAZZ', 
      first_name: this.tenant ? this.tenant.name : 'Administrador',
      last_name: this.tenant ? this.tenant.last_name : 'ZAZZ',
      email: this.tenant ? this.tenant.email : 'grupo.centurion.tech@gmail.com',
      phone: this.tenant ? this.tenant.phone : '5555555555',
      country: "MX",
      state: "CX",
      city: "CDMX",
      address: this.settlement?.address,
      zip_code: this.settlement?.zip,
      profile_id: this.profile.id,
      customer_id: generic_default_cus
    };

    let payment: any = null;
    this.loadingMsg = `Comunicando con el motor de pago ${this.settlement?.merchant_id}...`;

    if (this.tenant) {
      if (Array.isArray(this.tenant)) {
        // TODO: si es un arreglo debería tomarse el primer tenant?
        const tenant = this.tenant.length > 0 ? this.tenant[0] : null;
        if (tenant) {
          payload.customer_id = tenant.customer_id;
        } else {
          // TODO: definir qué pasa si no hay tenants ?
        }
      } else {
        if (this.tenant.customer_id) {
          payload.customer_id = this.tenant.customer_id;
        } else {
          let customer: any = await this.merchantOpenpayCustomer(this.tenant);
          payload.customer_id = customer.id;
        }
      }
      
    }

    payment = await this.merchantOpenpay(payload);
    if (payment) {
      payload.transaction_id = payment.order_id;
      receiptPayload.paymentData.transaction_id = payment.payment_method.reference;
      let barcode: any = await this.image.getBase64ImageFromUrl(payment.payment_method.barcode_url);
      receiptPayload.paymentData.barcode = "data:image/jpeg;base64," + barcode.split(',')[1];
      receiptPayload.paymentData.merchant_id = 'openpay'; // this.bill.merchant_id;
    } else {
      this.toastr.error('Ocurrió un error al procesar el pago.', 'Error');
      this.loadingMsg = '';
      this.loading = false;
      return;
    }

    this.loadingMsg = 'Respuesta exitosa, creando transacción...';
    console.log('receiptPayload ==> ', receiptPayload);

    await this.createCashTransaction({
      bill_id: this.bill?.id,
      transaction_id: receiptPayload.paymentData.transaction_id,
      amount: this.billForm.value.total?.toFixed(2),
      external_transaction_id: payload.transaction_id,
      merchant_id: receiptPayload.paymentData.merchant_id,
    }, () => {
      const { agreement, clabe, reference_name } = this.transactionLocal();
      receiptPayload.paymentData = { ...receiptPayload.paymentData, agreement, clabe, reference_name }
      this.createReceipt(receiptPayload);
      this.loadingMsg = 'Creando recibo...';
      this.store.publishBill(this.bill?.id, {...this.billForm.value, }).subscribe({
        next: (data: any) => {
          console.log('Bill published successfully', data);
          this.toastr.success('Recibo emitido correctamente.', 'Éxito');
          this.loadingMsg = '';
          this.loading = false;
          this.route.navigate(['/pagos/pendientes']);
        },
        error: (err: any) => {
          this.loadingMsg = '';
          console.error('Error al emitir el recibo !!!!!', err);
          this.toastr.error(`Ocurrió un error al emitir el recibo. ${err}`, 'Error');
          this.loading = false;
        },
        complete: () => {
          this.transactionLocal.set({
            agreement: '',
            clabe: '',
            reference_name: ''
          })
        }
      });
    });
    
  }

  private loadBillTransaction(id: number): void {
    this.transaction = null;
    // Use the receipt-scoped endpoint, also used by the invoice detail.
    this.store.getTransactionByBill(id).subscribe({
      next: transaction => {
        if (String(this.bill?.id) === String(id)) this.transaction = transaction;
      },
      error: () => {
        if (String(this.bill?.id) === String(id)) this.transaction = null;
      }
    });
  }

  publishInvoice(configs: any) {
    if (this.loading) return;
    if (this.bill?.invoiced || this.bill?.invoice_id || this.invoiceData?.invoice?.id || this.invoiceData?.id) {
      this.toastr.error('Este recibo ya tiene una factura. Descarga la existente desde el recibo.', 'Factura existente');
      return;
    }
    this.loading = true;

    console.log('PUBLISH INVOICE configs =>', configs.metodo);

    let receptor: any = {};

    receptor = {
        RFC: this.invoiceForm.value.rfc,
        NombreRazonSocial: this.invoiceForm.value.razon_social,
        UsoCFDI: this.invoiceForm.value.uso_cfdi,
        RegimenFiscal: this.invoiceForm.value.regimen_fiscal,
        Direccion: {
          Calle: "",
          NumeroExterior: "",
          NumeroInterior: "",
          Colonia: "",
          Localidad: "",
          Municipio: "",
          Estado: "",
          Pais: "",
          CodigoPostal: this.invoiceForm.value.zip_code
        }
      };

    const encabezados: any = {
      CFDIsRelacionados: "",
      TipoRelacion: "04",
      Receptor: receptor,
      Serie: this.serie.toString(),
      Folio: this.billForm.value.id.toString(),
      MetodoPago: configs.metodoPago,
      FormaPago: configs.formaPago,
      Moneda: "MXN",
      LugarExpedicion: this.invoiceForm.value.zip_code
    };

    this.complemento = {
      formaPago: configs.formaPago,
      serie: this.serie,
      folio: this.billForm.value.id,
      usoCFDI: this.invoiceForm.value.uso_cfdi,
      metodoPago: configs.metodoPago,
    }

    const currentBill = this.billForm.getRawValue();
    const payload: any = {
      bill: currentBill,
      profile_id: this.profile.id,
      Encabezado: encabezados,
      Conceptos: this.bill_items,
      complemento: this.complemento,
      utilityData: this.utilityData,
    };
    

    this.persistCurrentBill(currentBill).pipe(
      switchMap(() => this.store.createInvoice(payload))
    ).subscribe({
      next: (data: any) => {
        this.invoiceData = data;
        // PDF generation can fail after successful stamping. Do not allow a second stamp.
        if (this.bill) {
          this.bill.invoiced = true;
          this.bill.invoice_id = data?.invoice?.id ?? data?.id ?? this.bill.invoice_id;
        }
        this.loadingMsg = 'Generando factura...';
        this.download();
        this.toastr.success('Factura timbrada correctamente.', 'Éxito');
        this.modalInvoiceConfig.dismiss();
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error(err?.error?.error ?? 'No se pudo emitir la factura.', 'Error');
        this.loading = false;
      }
    });      
  }

  async regenerateReceipt() {
    let dueDate = new Date(this.bill?.due_date!);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    this.paymentService.getLastCashTransaction(this.bill?.id).subscribe({
      next: (data: any) => {
        let paymanetData: any = {}

        let receiptPayload = {
          bill: this.billForm.value,
          bill_items: this.bill?.bill_items,
          dueDate: dueDate,
          unitData: this.unit,
          buildingData: this.settlement,
          paymentData: paymanetData,
          utilityData: this.utilityData,
          tenantData: this.tenant,
        };
        receiptPayload.paymentData.transaction_id = data?.transaction_id ?? '';
        receiptPayload.paymentData.merchant_id = this.settlement?.merchant_id;
        console.log('receiptPayload => ', receiptPayload);
        this.createReceipt(receiptPayload);
      }
    });
  }

  async regenerateInvoice() {
    console.log('regenerateInvoice ==> ', this.bill);
    if (this.bill?.invoice_id != null) {
      const invoiceId = this.bill.invoice_id;
      const currentBill = this.billForm.getRawValue();
      // Re-downloading an existing invoice must not save an unchanged receipt:
      // the update endpoint can reset an issued receipt to draft.
      const saveChanges = this.billForm.dirty
        ? this.persistCurrentBill(currentBill)
        : of(null);

      saveChanges.pipe(
        switchMap(() => this.store.getInvoice(invoiceId))
      ).subscribe({
        next: (data: any) => {
          this.invoiceData = data.invoice;
          this.download();          
        },
        error: (err: any) => {
          console.log(err);
        }
      });
    }
  }

  async merchantActnet(payload: any) {

    let payment: any = await this.paymentService.createPaymentStoreActnet(payload);

    console.log('PAYMENT ACTNET => ', payment);

    if (payment != undefined && (payment.status_code == 4 || payment.transaction_id == null)) {
      console.log('paymentFailed => ', payment.error);
      this.toastr.error(`El motor de pago no logró la comunicación, por favor intentar más tarde. <br><br> <strong>${payment.error.error_message}</strong>`, 'Error', {
        enableHtml: true,
      });
      this.loadingMsg = 'Error de motor de pago...';
      this.store.updateFailedPayment(this.bill?.id).subscribe({
        next: (data: any) => {
          console.log('updateFailedPayment => ', data);
          this.billForm.patchValue(data);
        },
        error: (err: any) => {
          console.log('updateFailedPayment ERROR => ', err);
        }
      });
      // this.support.paymentFailed(payment.error);
      this.loadingMsg = '';
      this.loading = false;
      // window.location.reload();
      return null;
    }

    return payment;
  }

  async merchantOpenpay(payload: any) {
    let payment: any = await this.paymentService.createOpenpayStore(payload);

    if (payment != undefined && payment['ErrorCode']) {
      console.log('paymentFailed => ', payment.error);
      this.toastr.error(`El motor de pago no logró la comunicación, por favor intentar más tarde. <br><br> <strong>${payment['Description']}</strong>`, 'Error', {
        enableHtml: true,
      });
      this.loadingMsg = 'Error de motor de pago...';
      this.store.updateFailedPayment(this.bill?.id).subscribe({
        next: (data: any) => {
          console.log('updateFailedPayment => ', data);
          this.billForm.patchValue(data);
        },
        error: (err: any) => {
          console.log('updateFailedPayment ERROR => ', err);
        }
      });

      this.loadingMsg = '';
      this.loading = false;
      // window.location.reload();
      return null;
    }

    console.log('PAYMENT OPENPAY => ', payment);

    return payment;
  }

  protected async merchantOpenpayCustomer(tenant: any) {
    console.log('merchantOpenpayCustomer => ', tenant);
    let payload: any = {};
    payload = tenant;
    payload.profile_id = this.profile.id;
    return await this.paymentService.createOpenpayCustomer(payload);
  }

  async createReceipt(payload: any) {
    this.store.createReceipt(payload).subscribe({
      next: (data: any) => {
        console.log('CREATE RECEIPT !!!!!!!');
        this.store.saveReceipt(this.bill?.id, { pdf: data.filename }).subscribe((data: any) => {
          console.log('saveReceipt => ', data);
        });

        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });
        let fileURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();

        return;
      },
      error: (err: any) => {
        console.log('createReceipt ERROR => ', err);
        this.toastr.error('Ocurrió un error al crear el recibo', 'Error');
        this.loading = false;
      }
    });
  }

  download() {
    let dueDate = new Date(this.billForm.value.due_date);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);
    //
    this.store.downloadInvoice({
      bill: this.getCurrentBill(),
      dueDate: dueDate,
      unitData: this.unit,
      settlementData: this.settlement,
      buildingData: this.building,
      utilityData: this.utilityData,
      invoiceData: this.invoiceData,
      prev_bill: this.prev_bill,
    }).subscribe({
      next: async (data: any) => {
        console.log('downloadInvoice => ', data.result.data);
        await this.store.saveInvoicePdf(this.invoiceData.id, { pdf: data.filename }).subscribe((response: any) => {
          

          const int8Array = new Uint8Array(data.result.data);
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          var fileURL = window.URL.createObjectURL(blob);
          var link=document.createElement('a');

          link.href = fileURL;
          link.download = data.filename;
          link.click();

          const blob2 = new Blob([this.invoiceData.cfdixml], { type: 'application/xml' });

          var fileURL2 = window.URL.createObjectURL(blob2);
          var link2=document.createElement('a');

          link2.href = fileURL2;
          link2.download = `${this.invoiceData.serie}_${this.invoiceData.folio}.xml`;
          link2.click();

          window.location.reload();
          this.loading = false;
          
          return;
        });
      }, error: (error: any) => {
        this.toastr.error('Ocurrió un error al descargar la factura', 'Error');
        console.log('createReceipt ERROR => ', error);
        this.loading = false;
      }
      
    });
  }

  private getCurrentBill(): Bill {
    return {
      ...(this.bill ?? {}),
      ...this.billForm.getRawValue()
    } as Bill;
  }

  private persistCurrentBill(currentBill = this.billForm.getRawValue()): Observable<any> {
    return this.store.updateBill(this.bill?.id, currentBill).pipe(
      tap(() => {
        this.bill = {
          ...(this.bill ?? {}),
          ...currentBill
        } as Bill;
      })
    );
  }

  payBill(): void {
    this.loading = true;

    if (this.billForm.invalid) {
      this.billForm.markAllAsTouched();
      this.toastr.error('Favor de llenar todos los campos', 'Error');
      this.loading = false;
      return;
    }

    this.billForm.patchValue({
      status: true
    });

    let dueDate = new Date(this.bill?.due_date!);
    dueDate.setDate(dueDate.getDate());
    dueDate.toISOString().substring(0, 10);

    // this.bill.medidor = this.meterImages;
    let paymanetData: any = {}
    paymanetData.merchant_id = 'openpay';
    paymanetData.transaction_id = '';

    let receiptPayload = {
      bill: this.billForm.value,
      dueDate: dueDate,
      unitData: this.unit,
      buildingData: this.settlement,
      paymentData: paymanetData,
      utilityData: this.utilityData,
    };

    receiptPayload.bill.transaction_id = Date.now();

    this.store.createReceipt(receiptPayload).subscribe({
      next: (data: any) => {
        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });
        let fileURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');

        link.href = fileURL;
        link.download = data.filename;
        link.click();

        this.billForm.patchValue({
          pdf: data.filename
        });

        this.store.publishBill(this.bill?.id, this.billForm.value).subscribe({
          next: (data: any) => {
            let payload: any = {
              transaction_id: receiptPayload.bill.transaction_id,
              amount: '0',
              currency: 'MXN',
              status_code: '3',
              error_code: '00',
              error_message: 'Approved',
              payment_method_bin: '0',
              payment_method_type: 'SALDO',
              payment_method_brand: 'SALDO',
              bill_id: this.bill?.id,
              external_transaction_id: this.bill?.id
            }

            this.store.createTransaction(payload).subscribe({
              next: (data: any) => {
                this.toastr.success('Recibo creado correctamente.', 'Éxito');
                this.loading = false;
                this.route.navigate(['/pagos/pendientes']);
              },
              error: (err: any) => {
                this.toastr.error('Ocurrió un error al crear el recibo', 'Error');
                this.loading = false;
              }
            });
          },
          error: (err: any) => {
            this.toastr.error('Ocurrió un error al crear el recibo', 'Error');
            this.loading = false;
          }
        });
      },
      error: (err: any) => {
        this.toastr.error('Ocurrió un error al crear el recibo', 'Error');
        this.loading = false;
      }
    });
  }

  protected updateBill(): void {
    this.loading = true;

    if (this.billForm.invalid) {
      this.billForm.markAllAsTouched();
      this.toastr.error('Favor de llenar todos los campos', 'Error');
      this.loading = false;
      return;
    }

    this.store.updateBill(this.bill?.id, this.billForm.value).subscribe({
      next: (data: any) => {
        this.toastr.success('Recibo actualizado correctamente', 'Éxito');
        console.log('updateBill => ', data);
        window.location.reload();
        this.billForm.patchValue(data);
        this.loading = false;
      }, 
      error: (err: any) => {
        this.toastr.error('Favor de llenar todos los campos', 'Error');
        this.loading = false;
      }
    });
  }

  // resendBill() {}

  async createCashTransaction(data: any, callback: () => void) {
    console.log('createCashTransaction => ', data);
    let payload: any = {
      transaction_id: data.transaction_id,
      amount: data.amount,
      currency: 'MXN',
      status_code: '1',
      error_message: 'Pending',
      payment_method_bin: '0',
      payment_method_type: 'CASH',
      payment_method_brand: 'CASH',
      bill_id: data.bill_id,
      external_transaction_id: data.external_transaction_id,
      merchant_id: data.merchant_id,
    }

    console.log('createCashTransaction PAYLOAD => ', payload);
  
    await this.store.createTransaction(payload).subscribe({
      next: (data: any) => {
        const {agreement, clabe, reference_name} = data;
        this.transactionLocal.set({
          agreement, clabe, reference_name
        });
        callback();
        this.loading = false;
      },
      error: (err: any) => {
        console.error('Error creating cash transaction', err);
        this.loading = false;
      }
    });
  }

  updateDismissed() {
    this.loading = true;    
  }

  removeItem(event: any) {
    console.log('REMOVE ITEM EVENT => ', event);
    this.store.deleteBillItem(event.id).subscribe({
      next: (data: any) => {
        this.toastr.success('Concepto eliminado correctamente', 'Éxito');
        this.loadBill(this.billForm.value.id);
      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error('Ocurrió un error al eliminar el concepto', 'Error');
      }
    });
  }

  loadAuditTrail(): void {
    if (!this.bill?.id) {
      this.toastr.error('No se puede cargar el historial sin un ID de recibo válido', 'Error');
      return;
    }

    this.auditTrailLoading = true;
    this.auditTrailData = null;

    this.store.getBillAuditTrail(this.bill.id).subscribe({
      next: (data: any) => {
        console.log('Audit trail data:', data);
        this.auditTrailData = data;
        this.auditTrailLoading = false;
      },
      error: (err: any) => {
        console.error('Error loading audit trail:', err);
        this.toastr.error('Error al cargar el historial de cambios', 'Error');
        this.auditTrailLoading = false;
      }
    });
  }

  onBillUpdated(updatedBill: Bill) {
    // Update the bill object with the changes
    this.bill = updatedBill;
    console.log('Bill updated:', updatedBill);
    
    // Optionally reload the bill to get the latest data from the server
    // this.loadBill(this.bill.id);
  }
}
